'use client';

import HeroSearch from "@/components/sections/HeroSearch";
import CategoryButtons from "@/components/sections/CategoryButtons";
import CollectionsSlider from "@/components/sections/CollectionsSlider";
import MasonryGallery from "@/components/sections/MasonryGallery";
import PremiumCTA from "@/components/sections/PremiumCTA";
import { BrandOnboardingModal } from "@/components/onboarding";
import { useOnboardingCheck } from "@/hooks/useOnboardingCheck";

export default function HomeView() {
  const { shouldShowOnboarding, completeOnboarding, dismissOnboarding } = useOnboardingCheck();

  return (
    <>
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-4 pb-24 sm:px-6 lg:px-8 xl:max-w-[1560px] 2xl:max-w-[1680px]">
        <HeroSearch />
        <CollectionsSlider />
        <CategoryButtons />
        <MasonryGallery />
        <PremiumCTA />
      </div>

      {/* Brand Onboarding Modal - shows for new users */}
      <BrandOnboardingModal
        isOpen={shouldShowOnboarding}
        onComplete={completeOnboarding}
        onDismiss={dismissOnboarding}
      />
    </>
  );
}
